export default class initObserver {
  constructor() {
    const elem = document.querySelectorAll('.js-anim');
    const options = {
      rootMargin: '-30% 0px',
    };

    const addClass = (target) => {
      target.classList.add('is-visible');
    };

    const observeUse = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          addClass(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observeUse, options);
    elem.forEach(iSObserver => {
      observer.observe(iSObserver);
    });

    const gotop = document.querySelectorAll('.js-kv');

    const gotopObserveUse = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.querySelector('.js-gotop').classList.remove('is-visible');
        } else {
          document.querySelector('.js-gotop').classList.add('is-visible');
        }
      });
    };

    const gotopObserver = new IntersectionObserver(gotopObserveUse, {
      rootMargin: '-50% 0px 0px 0px',
    });
    gotop.forEach(iSObserver => {
      gotopObserver.observe(iSObserver);
    });

  }
}
